<!--审核专家修改品目申请弹框-->
<template>
  <a-modal width="90vw"
           centered
           :footer="false"
           :closable="false"
           :visible="modalVisible"
           :destroyOnClose="true">
    <div style="margin: -24px">
      <div class="zjmp">
        <a-row type="flex"
               style="flex-wrap: nowrap">
          <a-col flex="0 0 auto"
                 style="width: 500px">
            <div class="left">
              <div class="zjmp_t1">
                <expert-upload-view avatar-flag
                                    config-key="expert.apply.peoplePicture"
                                    :refer-id="expertInfo.id" />
                <div class="info">
                  <div class="r1">
                    <span class="text1">{{ expertInfo.expertName }}</span>
                    <span>
                      <span class="tag"
                            v-for="item in expertInfo.extras.tagInfos"
                            :style="'color:'+item.tagColor "
                            :key="item.id">{{ item.tagName }}</span>
                      <span class="tag v2"
                            v-if="expertInfo.emergencyFlag === '1'"><a-icon type="thunderbolt"
                                theme="filled" />{{ expertInfo.extras.emergencyFlagText }}</span>
                    </span>
                  </div>
                  <div class="text2">{{ expertInfo.idCard }}</div>
                  <div class="text2">{{ expertInfo.mobilePhone }}</div>
                  <div class="text2">{{ expertInfo.extras.areaAddressText }}</div>
                  <div class="text2">
                    状态：
                    <a-tag color="#5DCC6F">{{ expertInfo.extras.stateText }}</a-tag>
                  </div>
                </div>
              </div>
              <div class="zjmp_t2"></div>
              <div class="zjmp_t3">
                <!-- 正常-->
                <div>入库：{{ expertInfo.addDate | dateFormat }}</div>
                <div>已入库<b>{{ expertInfo.addDate | fromNow  }}</b>天</div>
                <!--   已出库-->
                <template v-if="expertState.STATE.OUT_SUCCESS === expertInfo.state">
                  <div>出库：{{ expertInfo.stockOutDate  | dateFormat }}</div>
                  <div>原因:{{ expertInfo.stockOutReason }}</div>
                </template>
              </div>
              <div v-if="readonly">
                <div class="zjmp_t3">
                  审核人：<div>{{ pendingAuditApplyForData.auditUserName }}</div>
                </div>
                <div class="zjmp_t3">
                  审核时间：<div>{{ pendingAuditApplyForData.auditDate | dateFormat }}</div>
                </div>
                <div class="zjmp_t3">
                  审核结果：<a-tag :color="AuditStateEnum.getValOrCol(pendingAuditApplyForData.auditState).color">{{ AuditStateEnum.getValOrCol(pendingAuditApplyForData.auditState).value }}</a-tag>
                </div>
                <div class="zjmp_t3"
                     v-if="pendingAuditApplyForData.auditState == AuditStateEnum.REFUSE[0]">
                  不同意修改意见：<div>{{ pendingAuditApplyForData.auditFailReason }}</div>
                </div>
              </div>
              <div v-else>
                <a-form-model ref="auditForm"
                              :model="pendingAuditApplyForData"
                              :rules="rules"
                              :label-col="labelCol"
                              :wrapper-col="wrapperCol">
                  <a-form-model-item label="是否同意修改"
                                     prop="auditState">
                    <a-radio-group v-model="pendingAuditApplyForData.auditState">
                      <a-radio value="1">同意修改</a-radio>
                      <a-radio value="2">不同意修改</a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                  <a-form-model-item label="不同意原因"
                                     prop="auditFailReason"
                                     v-if="pendingAuditApplyForData.auditState==AuditStateEnum.REFUSE[0]">
                    <a-input v-model="pendingAuditApplyForData.auditFailReason"
                             placeholder="请输入不同意原因"
                             type="textarea"
                             :auto-size="{ minRows: 4 }" />
                  </a-form-model-item>
                </a-form-model>
                <a-row :gutter="[12, 8]"
                       type="flex"
                       justify="center">
                  <a-col :span="12">
                    <a-button :loading="submitLoading"
                              @click="onSubmitApplyFor"
                              type="primary"
                              block>提交</a-button>
                  </a-col>
                </a-row>
              </div>
            </div>
          </a-col>
          <a-col style="width: 100%;overflow: auto">
            <div class="descriptions right">
              <a-row>
                <a-col :span="24">
                  <div class="box">
                    <span>原评审品目：</span><b style="color: red">{{ expertEditPurchaseItemApplyFor.beforeEditPurchaseItem }}</b>
                  </div>
                </a-col>
                <a-col :span="24">
                  <div class="box">
                    <span>修改后评审品目：</span><b style="color: red">{{ expertEditPurchaseItemApplyFor.afterEditPurchaseItem }}</b>
                  </div>
                </a-col>
                <a-col :span="24">
                  <div class="box">
                    <span>申请日期：<b>{{expertEditPurchaseItemApplyFor.applyForDate | dateFormat}}</b></span>
                  </div>
                </a-col>
                <a-col :span="24">
                  <div class="box">
                    <span>申请理由：<b>{{expertEditPurchaseItemApplyFor.editReason}}</b></span>
                  </div>
                </a-col>
              </a-row>
            </div>
          </a-col>
        </a-row>
        <div class="btn_box">
          <a-button type="danger"
                    @click="onClose()">
            <a-icon type="close" />
          </a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import ExpertUploadView from '@/components/selector/ExpertUploadView.vue'
import { GetPendingAuditApplyForById, SubmitAuditApplyFor } from '@/epp/expertmain/pendingauditapplyfor/api/ApplyForApi'
import { ExpertState } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import { AuditStateEnum } from '@/epp/expertmain/pendingauditapplyfor/util/ApplyForUtil'

export default {
  name: 'AuditExpertEditPurchaseApplyFor',
  components: {
    ExpertUploadView
  },
  data () {
    return {
      AuditStateEnum: AuditStateEnum,
      submitLoading: false,
      readonly: false,
      expertState: ExpertState,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      rules: {
        auditState: [{ required: true, message: "请选择是否同意", trigger: 'change' }],
        auditFailReason: [{ required: true, message: "请输入不同意原因", trigger: 'blur' }],
      },
      modalVisible: false,
      expertInfo: {
        extras: {}
      },
      expertEditPurchaseItemApplyFor: {},
      pendingAuditApplyForData: {}
    }
  },
  methods: {
    /**
     * 初始化数据
     * @param pendingAuditApplyForId 待审核申请表ID
     */
    async initData (pendingAuditApplyForId, readonly) {
      const res = await GetPendingAuditApplyForById(pendingAuditApplyForId)
      const result = res.result
      if (res.code == 200 && result) {
        this.pendingAuditApplyForData = result.pendingAuditApplyForData
        if (!readonly) {
          this.pendingAuditApplyForData.auditState = AuditStateEnum.APPROVE[0]
        }
        this.expertInfo = result.expertInfo
        this.expertEditPurchaseItemApplyFor = result.expertEditPurchaseItemApplyFor
        this.readonly = readonly
        this.modalVisible = true
      } else {
        this.$error({
          title: '此申请不存在',
        })
      }
    },
    onSubmitApplyFor () {
      this.$refs.auditForm.validate(valid => {
        if (valid) {
          this.handleSubmitApplyFor()
        } else {
          return false
        }
      })
    },
    async handleSubmitApplyFor () {
      this.submitLoading = true
      const res = await SubmitAuditApplyFor(this.pendingAuditApplyForData)
      if (res.code == 200) {
        this.$message.success('处理成功')
        this.modalVisible = false
        this.$emit("submitSuccess")
      }
      this.submitLoading = false
    },
    onClose () {
      this.modalVisible = false
    },
  },
}
</script>

<style lang="less" scoped>
.link {
  color: rgb(24, 144, 255);
}

.action button {
  margin-right: 4px;
}

.card {
  margin-bottom: 24px;

  .extras {
    font-weight: 500;
    font-size: 16px;
  }
}

.nav {
  .title {
    text-align: center;
    font-weight: 800;
  }

  .footer {
    text-align: right;
  }
}

.titleCap {
  margin-bottom: 12px;

  .receiveNum {
    padding-left: 16px;
  }

  > span {
    border-right: 1px solid #e6e6e6;
    padding: 0 20px;
  }

  > span:nth-last-child(1) {
    border-right: none;
  }

  > span:nth-child(2) {
    padding-left: 0;
  }
}
.descriptions {
  font-size: 16px;
  margin-top: 120px;
  padding-right: 10px;
  .box {
    padding: 12px 20px;
    background: #f3f3f3;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .title {
    color: #62687e;
    margin-bottom: 8px;
  }

  span {
    color: #62687e;
  }

  b {
    color: #141414;
  }
}
/deep/ .zjmp .left {
  height: 650px;
}
</style>